import React from "react"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"

interface EditorProps {
  placeholder?: string;
  state: any
  setState: any
  id: string
}

export const TextAreaPersonalized: React.FC<EditorProps> = ({ placeholder, state, setState, id }) => {

  const handleChange = (html: string) => {
    setState({ ...state, [id]: html })
  }

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      ["link"],
      ["clean"]
    ],
    clipboard: {
      matchVisual: false,
    }
  }

  const formats = [
    "font", "size",
    "bold", "italic",
    "underline", "strike",
    "link",
  ]

  return (
    <div className='mb-5 mt-3'>
      <ReactQuill
        theme='snow'
        style={{ height: "100px", fontSize: "14px" }}
        onChange={handleChange}
        value={state[id]}
        modules={modules}
        formats={formats}
        bounds=".app"
        placeholder={placeholder}
      />
    </div>
  )
}
